import React from 'react';
const items = [{
  label: '6 Tomes · 300+ pages · 60+ session scripts · 29 worksheets',
  value: '$497'
}, {
  label: 'Bonus 01 — The 10-Minute Session Prep System',
  value: '$15'
}, {
  label: 'Bonus 02 — The Client Progress Proof Vault',
  value: '$18'
}, {
  label: 'Bonus 03 — The Coach’s Tool Finder Matrix',
  value: '$15'
}, {
  label: 'Bonus 04 — The Premium Delivery Makeover Kit',
  value: '$18'
}, {
  label: 'Bonus 05 — The Stuck Client Emergency Playbook',
  value: '$18'
}];
export function ValueStack() {
  return <section aria-labelledby="value-heading" className="w-full bg-white" data-id="element-237" data-mp="2my3xzkp2sgtw">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-238" data-mp="2965upqi1pf5n">
        <h2 id="value-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-239" data-mp="2d8kcs8dw4avv">
          Everything you get
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-cream-dark shadow-card" data-id="element-240" data-mp="30wk2r63dnx9e">
          <table className="w-full text-left" data-id="element-241" data-mp="35qy2fkp2oqjv">
            <thead data-id="element-242" data-mp="1tgekq3aa1uvb">
              <tr className="bg-sage-tint" data-id="element-243" data-mp="1tfweqextc2a7">
                <th className="px-5 sm:px-6 py-3.5 text-xs uppercase tracking-[0.14em] font-bold text-sage" data-id="element-244" data-mp="1og9z5yuii9y8">
                  Item
                </th>
                <th className="px-5 sm:px-6 py-3.5 text-xs uppercase tracking-[0.14em] font-bold text-sage text-right" data-id="element-245" data-mp="236r3bpyj7dyt">
                  Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-246" data-mp="2c49sn6j7kegi">
              {items.map(item => <tr key={item.label} className="bg-white" data-id="element-247" data-mp="283ptxyizl2s9">
                  <td className="px-5 sm:px-6 py-4 text-[15px] text-ink-soft" data-id="element-248" data-mp="2m4k5gq1bzjv5">
                    {item.label}
                  </td>
                  <td className="px-5 sm:px-6 py-4 text-[15px] font-semibold text-ink text-right whitespace-nowrap" data-id="element-249" data-mp="2h5h0f5lcpdn6">
                    {item.value}
                  </td>
                </tr>)}
              <tr className="bg-cream" data-id="element-250" data-mp="msr64mr2m2f9">
                <td className="px-5 sm:px-6 py-4 font-serif font-bold text-ink text-lg" data-id="element-251" data-mp="2mtfmqo3fgs1x">
                  Total value
                </td>
                <td className="px-5 sm:px-6 py-4 font-serif font-bold text-ink text-lg text-right" data-id="element-252" data-mp="2rt20cyn64ab9">
                  $581
                </td>
              </tr>
              <tr className="bg-terracotta" data-id="element-253" data-mp="30soy9agouxzk">
                <td className="px-5 sm:px-6 py-5 font-serif font-bold text-white text-lg" data-id="element-254" data-mp="30ui80ymllybs">
                  Today
                </td>
                <td className="px-5 sm:px-6 py-5 font-serif font-black text-white text-2xl text-right" data-id="element-255" data-mp="3ar4ufrukoxfx">
                  $27
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}